import { render, staticRenderFns } from "./editRole.vue?vue&type=template&id=fb9ad06c&scoped=true&"
import script from "./editRole.vue?vue&type=script&lang=ts&"
export * from "./editRole.vue?vue&type=script&lang=ts&"
import style0 from "./editRole.vue?vue&type=style&index=0&id=fb9ad06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9ad06c",
  null
  
)

export default component.exports